angular.module('impactx.invoice').controller('InvoiceCorrectionEditItemCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToastService',
    'TranslationService',
    'blhId',
    'dniId',
    'source',
    InvoiceCorrectionEditItemCtrl
]);

function InvoiceCorrectionEditItemCtrl($scope, dataGen, $mdDialog, ToastService, TranslationService, blhId, dniId, source) {
    var ctrl = this;

    $scope.source = source;

    function getData() {
        $scope.trns = {
            save: TranslationService.get('save'),
            abort: TranslationService.get('abort'),
            required: TranslationService.get('required'),
        };
        dataGen.getData($scope, {blhId: blhId, id: dniId}, '/invoice/complaint/correction/edititem');
    };

    ctrl.checkRequireCtrl = function (type) {
        let ctrlElem = $scope.data.control[type];
        if (ctrlElem) {
            return ctrlElem.showMust;
        }
        return false;
    };

    ctrl.save = function () {
        dataGen.postAsForm({}, {data: $scope.data}, '/invoice/complaint/correction/edititem/save').then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    getData();

}